<template>
  <div class="page-content OnlineBooking">
    <h1 class="page-title">
      {{ $locale("sideMenu.reports.onlineBooking") }}
      <el-tooltip popper-class="tooltip-content" effect="dark" :content="$locale('report.onlinebooking.spec')" placement="top">
        <img src="../../assets/img/tips.png" alt="Tips" />
      </el-tooltip>
    </h1>
    <!-- <span style="white-space: pre-line; font-size: 12px; color: #aaa;">{{ $locale("report.onlinebooking.spec") }}</span> -->
    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
        <el-col v-show="adminType === 'superAdmin'" :span="6">
          <RemoteSelectV2
            type="cinema"
            :list="comCinemaList"
            v-model="cinemaIdForAdmin"
            :isMultiple="false"
            :formValue.sync="cinemaIdForAdmin"
            @setList="arr => comCinemaList = arr"
          />
          <!-- <el-select
            :placeholder="$locale('form.plsSelectCinema')"
            v-model="cinemaIdForAdmin"
          >
            <el-option
              v-for="(cinema, idx) in cinemaList"
              :key="idx"
              :label="cinema.name"
              :value="cinema.id"
            ></el-option>
          </el-select> -->
        </el-col>
        <el-col :span="14">
          <DatePickerGroup
            v-model="filter"
            :showWeekly="true"
            :startPickerOptions="datePickerOptions"
            :endPickerOptions="datePickerOptions"
          />
          <el-button class="egl-btn-yellow" @click="search">{{ $locale("global.search") }}</el-button>
        </el-col>
        <el-col :span="10" class="ta-r" v-show="adminType !== 'superAdmin'">
            <el-button :disabled="tableData.length ? false : true" @click="downloadCsv" class="egl-btn-yellow">{{
            $locale("global.exportToCSV")
        }}</el-button>
        <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
        </el-col>
    </el-row>
    <el-row>
      <el-col :span="16">
        <el-checkbox-group v-model="showRule">
          <el-checkbox label="withoutTransactions">{{$locale("trans.box.witchoutTransactions")}}</el-checkbox>
        </el-checkbox-group>
      </el-col>
    </el-row>
    <div id="print">
      <div class="table-module">
        <div class="info-supplement-container">
          <el-row class="module-sms" :gutter="10">
            <el-col :span="3">{{ $locale("sideMenu.reports.onlineBooking") }}</el-col>
            <el-col :span="18"
              >{{ $locale("global.cinemaName") }}：{{ cinemaName }}</el-col
            >
            <!-- <el-col :span="6">会社名：{{ brandName }}</el-col> -->
            <el-col :span="3">{{ $locale('trans.report.generatedate') }}：{{ createTime }}</el-col>

          </el-row>
          <el-row class="module-sms" :gutter="10">
              <el-col :span="6"> 年月：{{ reportDateDisplay }} </el-col>
          </el-row>
        </div>
      </div>
      <div class="custom-border-table preSalesDailyDataTable">
        <el-table
          class="egl-table list-table"
          style="width: 100%"
          :data="tableData"
          :border="true"
          :span-method="objectSpanMethod"
          ref="onlineBookingTable"
          @filter-change="filter_fn"
          @sort-change="sort_fn"
        >
          <template v-for="(item, idx) in tableLabel">
            <el-table-column
              :fixed="idx <= 3"
              v-if="idx <= 3 || (item.prop === 'advanceSales' || item.prop === 'commissionFees') ? true : getIsExistBoxOffice(item.prop)"
              :key="idx"
              :label="item.label"
              :prop="item.prop"
              :min-width="item.width"
              :sortable="idx === 2 ? 'custom' : false"
              :align="'center'"
              :filters="item.filter && getFilterArr(item.filter)"
              :filtered-value="item.filter && getFilterValueArr(item.filter)"
              :column-key="item.columnKey && item.columnKey"
            >
              <el-table-column :min-width="180" v-if="idx >= 4 && idx < tableLabel.length - 1" label="枚数" :prop="item.prop + '_ticketQty'" align="center"></el-table-column>
              <el-table-column :min-width="180" v-if="idx >= 4 && idx < tableLabel.length - 1" label="興行収入" align="center">
                <template slot-scope="scope">
                  {{ scope.row[item.prop + '_ticketAmount'] | currencyFormat}}
                </template>
              </el-table-column>
              <el-table-column :min-width="180" v-if="idx >= 4 && idx < tableLabel.length - 1" label="席数" :prop="item.prop + '_vipQty'" align="center"></el-table-column>
              <el-table-column :min-width="180" v-if="idx >= 4 && idx < tableLabel.length - 1" label="席・バージョン追加料金" align="center">
                <template slot-scope="scope">
                  {{ scope.row[item.prop + "_vipAmount"] | currencyFormat}}
                </template>
              </el-table-column>
              <el-table-column :min-width="180" v-if="idx >= 4 && idx < tableLabel.length - 1" label="売上（追加料金を含む）" align="center">
                <template slot-scope="scope">
                  {{ scope.row[item.prop + "_salesTotal"] | currencyFormat}}
                </template>
              </el-table-column>
              <el-table-column :min-width="180" v-if="idx === tableLabel.length - 1" label="支払前" prop="freeHoldSeat_pendingCount" align="center"></el-table-column>
              <el-table-column :min-width="180" v-if="idx === tableLabel.length - 1" label="支払済み" prop="freeHoldSeat_payedCount" align="center"></el-table-column>
          </el-table-column>
          </template>
          
        </el-table>
      </div>
      <!-- add three tables -->
      <el-row :gutter="50" v-if="adminType === 'superAdmin'">
        <el-col :span="8">
          <el-table
            class="egl-table list-table"
            :border="true"
            :data="creditBrands"
          >
            <el-table-column
              :label="$locale('report.onlinebooking.creditBrands')"
              prop="creditBrand"
            ></el-table-column>
            <el-table-column
              :label="$locale('report.onlinebooking.visitor')"
              prop="visitor"
            >
            <template slot-scope="scope">
              {{ scope.row.visitor | qtyFormat}}
            </template>
            </el-table-column>
            <el-table-column
              :label="$locale('report.onlinebooking.total')"
              prop="total"
            >
              <template slot-scope="scope">
                {{ scope.row.total | currencyFormat}}
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="8">
          <el-table
            class="egl-table list-table"
            :border="true"
            :data="creditForwards"
          >
            <el-table-column
              :label="$locale('report.onlinebooking.creditForwards')"
              prop="creditForward"
            ></el-table-column>
            <el-table-column
              :label="$locale('report.onlinebooking.visitor')"
              prop="visitor"
            >
              <template slot-scope="scope">
                {{ scope.row.visitor | qtyFormat}}
              </template>
            </el-table-column>
            <el-table-column
              :label="$locale('report.onlinebooking.total')"
              prop="total"
            >
              <template slot-scope="scope">
                {{ scope.row.total | currencyFormat}}
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="8">
          <el-table
            class="egl-table list-table"
            :border="true"
            :data="gmoRefundFee"
          >
            <el-table-column
              prop="name"
            ></el-table-column>
            <el-table-column
              :label="$locale('report.onlinebooking.visitor')"
              prop="visitor"
            >
              <template slot-scope="scope">
                {{ scope.row.visitor | qtyFormat}}
              </template>
            </el-table-column>
            <el-table-column
              :label="$locale('report.onlinebooking.total')"
              prop="total"
            >
              <template slot-scope="scope">
                {{ scope.row.total | currencyFormat}}
              </template>
            </el-table-column>
            <el-table-column
              :label="$locale('global.fee')"
              prop="fee"
            >
              <template slot-scope="scope">
                {{ scope.row.fee | currencyFormat}}
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import "../../assets/style/onlineBooking.less";
import DatePickerGroup from "@/components/common/CommDatePickerGroup/DatePickerGroup";
// import DatePickerGroup from "@/components/DatePickerGroup";
import moment from "moment";
import { priceFormat, toThousands } from "../../utils/common";
import { getOnlineBooking } from "@/helpers/service/api/onlineBooking";
import { getCinemaList } from "@/helpers/service/api/common"
import elTableExport from "el-table-export";
import json2csv from "json2csv";
import momentTz from "moment-timezone";
import RemoteSelectV2 from '@/components/common/RemoteSelect-v2';
import { getExportName_fn } from '@/utils/common'
import { weekLocaleArray } from "@/utils/common";


const dayList = ["日", "月", "火", "水", "木", "金", "土"];

export default {
  components: {
    DatePickerGroup,
    RemoteSelectV2
  },
  data() {
    return {
      adminType: window.localStorage.getItem("adminType"),
      cinemaIdForAdmin: "",
      cinemaList: [],
      printObj: {
        popTitle: this.$locale("sideMenu.reports.onlineBooking"),
        id: "print"
      },
      today: 0,
      filter: {
        startDate: moment().startOf("day").valueOf(),
        endDate: moment().startOf("day").valueOf(),
      },
      reportDate: 0,
      reportDateDisplay: "",
      cinemaId: "",
      timeRange: "",
      cinemaName: "",
      brandName: "",
      createTime: "",
      nestedColumnList : [{
        label : "枚数",
        value : "ticketQty"
      },
      {
        label : "興行収入",
        value : "ticketAmount"
      },
      {
        label : "席数",
        value : "vipQty"
      },
      {
        label : "席・バージョン追加料金",
        value : "vipAmount"
      },
      {
        label : "売上（追加料金を含む）",
        value : "salesTotal"
      },
      {
        label : "支払前",
        value : "pendingCount"
      },
      {
        label : "支払済み",
        value : "payedCount"
      },
      ],
      filters_column: [],
      filters_values: [],
      boxOfficeType : [
        "boxOffice",
        "morningShow",
        "lateShow",
        "allNight",
        "special"
      ],
      startTime: this.today,
      endTime: this.today,
      searchValue: "",
      count: 0,
      isCheckZero: true,
      isCheckBuy: true,
      // typeArr: [],
      // groupArr: [],
      tableData: [],
      creditBrands: [],
      creditForwards: [],
      gmoRefundFee: [],
      grandTotalData: {},
      tableLabel: [
        {
          width: 200,
          label: "作品名",
          prop: "movie",
          filter: "movie",
          columnKey: "movie",
          // sortable: true,
        },
        {
          width: 150,
          label: "バージョン",
          prop: "version",
          filter: "version",
          columnKey: "version",
          // sortable: true,
        },
        // {
        //   width: 100,
        //   label: "スクリーン規格",
        //   prop: "version",
        //   //   filter: "film",
        //   //   columnKey: "film",
        //   sortable: true,
        // },
        // {
        //   width: 100,
        //   label: "字幕/吹替",
        //   prop: "subtitlesVersion",
        //   //   filter: "film",
        //   //   columnKey: "film",
        //   sortable: true,
        // },
        // {
        //   width: 100,
        //   label: "その他バージョン",
        //   prop: "otherVersion",
        //   //   filter: "film",
        //   //   columnKey: "film",
        //   sortable: true,
        // },
        {
          width: 150,
          label: "公開週",
          prop: "week",
          // filter: "week",
          columnKey: "week",
          sortable: true,
        },
        {
          width: 150,
          label: "配給",
          prop: "distributor",
          filter: "distributor",
          columnKey: "distributor",
        },
        // Box office
        {
          width: 80,
          label: "本興行",
          prop: "boxOffice",
        },
        {
          width: 60,
          label: "モーニングショー",
          prop: "morningShow",
        },
        {
          width: 60,
          label: "レイトショー",
          prop: "lateShow",
        },
        {
          width: 80,
          label: "オールナイト",
          prop: "allNight",
        },
        {
          width: 80,
          label: "特別興行",
          prop: "special",
        },
        {
          width: 60,
          label: "合計",
          prop: "commissionFees",
        },
        {
          width: 60,
          label: "内前売券",
          prop: "advanceSales",
        },
        {
          width: 60,
          label: "ネット仮押チケット",
          prop: "freeHoldSeat",
        }
      ],
      //for filter column
      movieArr: [],
      movieIds: [],
      versionArr: [],
      versionIds : [],
      weekArr: [],
      weekIds : [],
      distributorArr: [],
      distributorIds : [],
      showRule: [ "withoutTransactions" ],
      datePickerOptions: {
        disabledDate: this.dateDisableDate,
      },
      comCinemaList: []
    };
  },
  filters: {
    currencyFormat(value) {
      return "¥" + toThousands(value);
    },
    qtyFormat(value) {
      return toThousands(value)
    }
  },
  mounted() {
    // const today = this.$moment().valueOf();

    // this.filter.startDate = today;
    // this.filter.endDate = today;
    // this.today = today;

    //this.search();
  },
  created() {
    if (this.adminType === "superAdmin") getCinemaList({
      status: "active",
      page: 0,
      pageSize: 20
    }, false).then(res => {
      this.comCinemaList = res.data.data
    })
    this.cinemaId = window.localStorage.getItem("cinemaId");
    //this.getList();
  },
  methods: {
    sort_fn() {
      //clear filter
      this.filters_column = [];
      this.filters_values = [];
      //switch sort order
      this.sort = this.sort === "ASC" ? "DESC" : "ASC";
      //call api to get data with updated sort value
      this.getList(this.filters_column, this.filters_values);
    },
    // getColumnLabelList() {
    //   const labelList = [];
    //   this.tableLabel.map((column, idx) => {

    //     if(idx < 4) {
    //       labelList.push({
    //         label: column.label,
    //         value: column.prop
    //       });
    //     }else{
    //       this.nestedColumnList.map((nestColumn, idx) =>{
    //         labelList.push({
    //           label: nestColumn.label,
    //           value: column.prop + "_" + nestColumn.value
    //         });
    //       });
    //     }
    //   });

    //   console.log("labelList", labelList);
    //   return labelList;
    // },
    getColumnLabelByPropName(propName) {
      let result = "";
      let isResultFound = false;

      this.tableLabel.map((column, idx) => {
        if(column.prop === propName) {
          result = column.label;
          isResultFound = true;
        }
      });

      if(isResultFound === false || result === "") {
        this.nestedColumnList.map((column, idx) => {
          if(column.value === propName) {
            result = column.label;
          }
        });
      }
      return result;
    },
    prepareTableDataToExportCsv() {
      //add header row x 2 before export, do not use default fields
      //special handle for table that has multiple column span
      const that = this;
      const originalTableData =  [ ...this.tableData ];
      const boxOfficeTypeRow = { ...originalTableData[0] };
      const valueNameRow = { ...originalTableData[0] };
      //construct valueNameRow = 枚数/興行収入...etc
      Object.keys(valueNameRow).map(function(key, index) {
        if(key.includes("Qty") || key.includes("Amount")  || key.includes("salesTotal") || key.includes("pendingCount") || key.includes("payedCount"))
        {
          const keySplit = key.split("_");
          return valueNameRow[key] = that.getColumnLabelByPropName(keySplit[1]);
        }
        return valueNameRow[key] = "";
      });
      //put this row at the top of tableData
      originalTableData.unshift({ ...valueNameRow });

      //construct boxOfficeTypeRow = 本興行/モーニングショー...etc
      let countNestedField = 0;
      Object.keys(boxOfficeTypeRow).map(function(key, index) {

        //reset after 5 as 枚数/興行収入..etc only has 5 column
        if(countNestedField === 5) { countNestedField = 0; }

        if(key.includes("Qty") || key.includes("Amount") || key.includes("_salesTotal") || key.includes("pendingCount") || key.includes("payedCount"))
        {
          const keySplit = key.split("_");
          //only fill once boxOfficeType
          countNestedField ++;
          if(countNestedField === 1) {
            return boxOfficeTypeRow[key] = that.getColumnLabelByPropName(keySplit[0]);
          }
          return boxOfficeTypeRow[key] = "";
        }
        return boxOfficeTypeRow[key] = that.getColumnLabelByPropName(key);
      });
      //put this row at the top of tableData
      originalTableData.unshift({ ...boxOfficeTypeRow });

      return originalTableData;
    },
    downloadCsv() {
      const theData = this.prepareTableDataToExportCsv();
      try {
        const result = json2csv.parse(theData, {
          // fields: this.getColumnLabelList(), //we do not use fields to generate table head
          header: false
        });
        // determine browser type
        if ((navigator.userAgent.indexOf("compatible") > -1 &&
            navigator.userAgent.indexOf("MSIE") > -1) ||
            navigator.userAgent.indexOf("Edge") > -1) {
          //IE10 or Edge
          let BOM = "\uFEFF";
          let csvData = new Blob([ BOM + result ], { type: "text/csv" });
          navigator.msSaveBlob(csvData, `${this.$locale("trans.box.online")}[${this.reportDateDisplay}]`);
        } else {
          //non-IE
          let csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
          //use a tag to implement download
          let link = document.createElement("a");
          link.href = encodeURI(csvContent);
          link.download = 
          // `${this.$moment().format("YYYYMMDDHHmm")}_${this.$locale("trans.box.online")}[${this.reportDateDisplay}]`;
          getExportName_fn(
            `${this.$locale("trans.box.online")}`,
            '',
            '',
            '',
            `${this.$moment(this.filter.startDate).format('YYYY-MM-DD')} （${weekLocaleArray[this.$moment(this.filter.startDate).day()]}）~ ${this.$moment(this.filter.endDate).format('YYYY-MM-DD')} （${weekLocaleArray[this.$moment(this.filter.endDate).day()]}）`,
            this.cinemaName,
            this.$moment().format('YYYYMMDDHHmm')
          )
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } catch (err) {
        // alert(err);
      }
    },
    // exportCsv() {
    //   const that = this;
    //   if (that.tableData.length > 0) {
    //     that.size = 0;
    //     that.$nextTick(function() {
    //       elTableExport(that.$refs.onlineBookingTable, {
    //         fileName: "export-trans",
    //         type: "xls",
    //         withBOM: false,
    //         useFormatter: true,

    //       })
    //         .then(() => {
    //           that.size = 10;
    //         })
    //         .catch(err => {
    //           that.size = 10;
    //           console.info("Error: " , err);
    //         });
    //     });
    //   }
    // },
    getList(filters_column, filters_values, isFilter = false) {
      //reset tableData
      this.tableData = [];

      getOnlineBooking({
        superAdmin: this.adminType === "superAdmin",
        cinemaId: this.adminType === "superAdmin" ? this.cinemaIdForAdmin : this.cinemaId,
        startDate: moment(this.filter.startDate).format("YYYY-MM-DD"),
        endDate: moment(this.filter.endDate).format("YYYY-MM-DD"),
        sort: this.sort,
        ...(filters_column ? { typeName: filters_column } : {}),
        ...(filters_values ? { typeNameValueList: filters_values } : {}),
      }).then(res => {
        //check if has data
        // if(!res.data) { return; }

        this.tableData = res.data && res.data.records ? res.data.records : [];
        this.creditBrands = res.data && res.data.creditBrands ? res.data.creditBrands : [];
        this.creditForwards = res.data && res.data.creditForwards ? res.data.creditForwards : [];
        this.gmoRefundFee = res.data && res.data.gmoRefundFee ? [
          {
            name: "キャンセル",
            visitor: res.data.gmoRefundFee.visitor,
            total: res.data.gmoRefundFee.total,
            fee: res.data.gmoRefundFee.fee
          }
        ] : []
        this.grandTotalData = res.data && res.data.grandTotal ? res.data.grandTotal : [];
        this.tableData.length > 0 && this.dataGrouping();
        // this.tableData.map(item => {
        //   item.advanceSales.total = "¥" + toThousands(item.advanceSales.total);
        //   item.advanceSalesVipSeat.total = "¥" + toThousands(item.advanceSalesVipSeat.total);
        //   item.allNight.total = "¥" + toThousands(item.allNight.total);
        //   item.allNightVipSeat.total = "¥" + toThousands(item.allNightVipSeat.total);
        //   item.boxOffice.total = "¥" + toThousands(item.boxOffice.total);
        //   item.boxOfficeVipSeat.total = "¥" + toThousands(item.boxOfficeVipSeat.total);
        //   item.commissionFees.total = "¥" + toThousands(item.commissionFees.total);
        //   item.commissionFeesVip.total = "¥" + toThousands(item.commissionFeesVip.total);
        //   item.lateShow.total = "¥" + toThousands(item.lateShow.total);
        //   item.lateShowVipSeat.total = "¥" + toThousands(item.lateShowVipSeat.total);
        //   item.morningShow.total = "¥" + toThousands(item.morningShow.total);
        //   item.morningShowVipSeat.total = "¥" + toThousands(item.morningShowVipSeat.total);
        //   item.special.total = "¥" + toThousands(item.special.total);
        //   item.specialVipSeat.total = "¥" + toThousands(item.specialVipSeat.total);
        // });
        // Object.keys(this.grandTotalData).forEach(key => {
        //   this.grandTotalData[key].total = "¥" + toThousands(this.grandTotalData[key].total);
        //   // item.advanceSales.total = 
        //   // item.advanceSalesVipSeat.total = toThousands(item.advanceSalesVipSeat.total);
        //   // item.allNight.total = toThousands(item.allNight.total);
        //   // item.allNightVipSeat.total = toThousands(item.allNightVipSeat.total);
        //   // item.boxOffice.total = toThousands(item.boxOffice.total);
        //   // item.boxOfficeVipSeat.total = toThousands(item.boxOfficeVipSeat.total);
        //   // item.commissionFees.total = toThousands(item.commissionFees.total);
        //   // item.commissionFeesVip.total = toThousands(item.commissionFeesVip.total);
        //   // item.lateShow.total = toThousands(item.lateShow.total);
        //   // item.lateShowVipSeat.total = toThousands(item.lateShowVipSeat.total);
        //   // item.morningShow.total = toThousands(item.morningShow.total);
        //   // item.morningShowVipSeat.total = toThousands(item.morningShowVipSeat.total);
        //   // item.special.total = toThousands(item.special.total);
        //   // item.specialVipSeat.total = toThousands(item.specialVipSeat.total);
        // });
        this.cinemaName = res.data ? res.data.cinema : "";
        this.brandName = res.data ? res.data.brand : "";
        this.createTime = res.data ? moment(new Date(res.data.exportAt)).format("YYYY-MM-DD HH:mm:ss") : "";

        if (res.data) {
          const reportStartDate = this.formatZoneDate(res.data.reportStart);
          console.log(reportStartDate);
          const startDay = dayList[new Date(reportStartDate).getDay()];
          console.log(startDay);
          const reportEndDate = this.formatZoneDate(res.data.reportEnd);
          const endDay = dayList[new Date(reportEndDate).getDay()];
          // this.reportDateDisplay = `${this.formatDate(reportStartDate)}（${startDay}）〜 ${this.formatDate(reportEndDate)}（${endDay}）`;
          this.reportDateDisplay = `${reportStartDate} (${startDay}) ~ ${reportEndDate} (${endDay})`;
        } else {
          this.reportDateDisplay = "";
        }
      });
    },
    // formatDate(timestamp) {
    //   // // let _time = moment(timestamp).utc().utcOffset(-1,true);
    //   // // return moment(moment(_time).valueOf()).format("YYYY-MM-DD");
    //   // console.log(moment(momentTz(timestamp).tz("America/Los_Angeles")).valueOf());
    //   // // return momentTz(timestamp).tz("America/Los_Angeles").format("YYYY-MM-DD");
      
    // },
    formatZoneDate(timestamp) {
      return momentTz.tz(timestamp, "Asia/Tokyo").format("YYYY-MM-DD");
    },
    getDate(obj) {
      this.filter = {
        startDate: obj.startDate,
        endDate: obj.endDate,
      };
    },
    rowspan(spanArr, position, spanName) {
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          spanArr.push(1);
          position = 0;
        } else if (
          this.tableData[index][spanName] ===
          this.tableData[index - 1][spanName] && this.checkIfSameGroup(this.tableData[index], this.tableData[index-1], spanName)
        ) {
          spanArr[position] += 1;
          spanArr.push(0);
        } else {
          spanArr.push(1);
          position = index;
        }
      });
    },
    checkIfSameGroup(thisRow, lastRow, key) {
      const commonKey = ["movie", "version", "subtitlesVersion", "otherVersion", "upcomingDate", "showTime" , "house", "bassType" , "sale"];
      //get current key idx
      const targetIdx = commonKey.indexOf(key);
      const lastKey = targetIdx > 0 ? commonKey[targetIdx - 1] : commonKey[targetIdx];
      //compare to last key
      if(thisRow[lastKey] === lastRow[lastKey]) {
        return true;
      }
      return false;
    },
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (row.movie === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (columnIndex === 1) {
        if (row.version === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (columnIndex === 2) {
        if (row.week === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (columnIndex === 3) {
        if (row.distributor && row.distributor.indexOf("合計") > -1) {
          return {
            rowspan: 1,
            colspan: 4,
          };
        }
        if (row.distributor === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    getTypeArr() {
      const keyArr = [];
      const newArr = [];
      this.tableData.forEach(item => {
        this.typeArr.push({
          inventoryType: item.inventoryType,
          groupName: item.groupName,
        });
        keyArr.push(item.inventoryType);
      });
      // 去重
      const newKey = new Set(keyArr);
      newKey.forEach(item => {
        const index = keyArr.findIndex(item2 => item2 === item);
        newArr.push(this.typeArr[index]);
      });
      this.typeArr = newArr;
    },
    // getGroupType() {
    //   getLogListService({ cinemaId: this.cinemaId }).then(res => {
    //     this.groupArr = res.data;
    //     this.groupArr.forEach(item => {
    //       item.value = item.id;
    //       item.text = item.name;
    //       this.groupIds.push(item.id);
    //     });
    //   });
    // },
    dataGrouping() {
      const allRecords = this.tableData;
      const finalArray = [];
      const grandTotal = this.grandTotalData;
      const { boxOfficeType } = this;

      allRecords.map((record, idx) => {
        const newObj = {};
        newObj["movie"] = record.movie;
        newObj["version"] = record.version;
        newObj["week"] = record.week;
        newObj["distributor"] = record.distributor;

        //handle filter array
        if(this.movieIds.indexOf(record.movie) === -1) {
          this.movieArr.push({
            text: record.movie,
            value: record.movie
          });
          this.movieIds.push(record.movie);
        }

        //handle filter array
        if(this.versionIds.indexOf(record.version) === -1) {
          this.versionArr.push({
            text: record.version,
            value: record.version
          });
          this.versionIds.push(record.version);
        }

        //handle filter array
        if(this.weekIds.indexOf(record.week) === -1) {
          this.weekArr.push({
            text: record.week,
            value: record.week
          });
          this.weekIds.push(record.week);
        }

        //handle filter array
        if(this.distributorIds.indexOf(record.distributor) === -1) {
          this.distributorArr.push({
            text: record.distributor,
            value: record.distributor
          });
          this.distributorIds.push(record.distributor);
        }

        boxOfficeType.map((type, idx) => {
          newObj[type + "_ticketQty"] = record[type].visitor;
          newObj[type + "_ticketAmount"] = record[type].total;
          newObj[type + "_vipQty"] = record[type].seatVisitor;
          newObj[type + "_vipAmount"] = record[type].seatTotal;
          newObj[type + "_salesTotal"] = record[type].allTotal;
        });

        //合計
        newObj["commissionFees_ticketQty"] = record.commissionFees.visitor;
        newObj["commissionFees_ticketAmount"] = record.commissionFees.total;
        newObj["commissionFees_vipQty"] = record.commissionFees.seatVisitor;
        newObj["commissionFees_vipAmount"] = record.commissionFees.seatTotal;
        newObj["commissionFees_salesTotal"] = record.commissionFees.allTotal;

        //内前売券
        newObj["advanceSales_ticketQty"] = record.advanceSales.visitor;
        newObj["advanceSales_ticketAmount"] = record.advanceSales.total;
        newObj["advanceSales_vipQty"] = record.advanceSales.seatVisitor;
        newObj["advanceSales_vipAmount"] = record.advanceSales.seatTotal;
        newObj["advanceSales_salesTotal"] = record.advanceSales.allTotal;

        // ネット仮押チケット
        newObj["freeHoldSeat_pendingCount"] = record.freeHoldSeatPendingCount;
        newObj["freeHoldSeat_payedCount"] = record.freeHoldSeatPayedCount;

        finalArray.push({  ...newObj });
      }); //end allFilm.map

      //all subtotal
      let lastRowSubTotal = {
        movie: undefined,
        version: undefined,
        week: undefined,
        distributor : "合計（全て）"
      };

      boxOfficeType.map((type, idx) => {
        lastRowSubTotal[type + "_ticketQty"] = grandTotal[type].visitor;
        lastRowSubTotal[type + "_ticketAmount"] = grandTotal[type].total;
        lastRowSubTotal[type + "_vipQty"] = grandTotal[type].seatVisitor;
        lastRowSubTotal[type + "_vipAmount"] = grandTotal[type].seatTotal;
        lastRowSubTotal[type + "_salesTotal"] = grandTotal[type].allTotal;
      });

      //合計
      lastRowSubTotal["commissionFees_ticketQty"] = grandTotal.commissionFees.visitor;
      lastRowSubTotal["commissionFees_ticketAmount"] = grandTotal.commissionFees.total;
      lastRowSubTotal["commissionFees_vipQty"] = grandTotal.commissionFees.seatVisitor;
      lastRowSubTotal["commissionFees_vipAmount"] = grandTotal.commissionFees.seatTotal;
      lastRowSubTotal["commissionFees_salesTotal"] = grandTotal.commissionFees.allTotal;

      //内前売券
      lastRowSubTotal["advanceSales_ticketQty"] = grandTotal.advanceSales.visitor;
      lastRowSubTotal["advanceSales_ticketAmount"] = grandTotal.advanceSales.total;
      lastRowSubTotal["advanceSales_vipQty"] = grandTotal.advanceSales.seatVisitor;
      lastRowSubTotal["advanceSales_vipAmount"] = grandTotal.advanceSales.seatTotal;
      lastRowSubTotal["advanceSales_salesTotal"] = grandTotal.advanceSales.allTotal;

      lastRowSubTotal.freeHoldSeat_payedCount = this.$_.sumBy(finalArray, "freeHoldSeat_payedCount");
      lastRowSubTotal.freeHoldSeat_pendingCount = this.$_.sumBy(finalArray, "freeHoldSeat_pendingCount");

      finalArray.push({  ...lastRowSubTotal });

      //update tableData
      this.tableData = finalArray;

      //sort filter array
      this.movieArr = this.sortArray(this.movieArr);
      this.versionArr = this.sortArray(this.versionArr);
      this.weekArr = this.sortArray(this.weekArr);
      this.distributorArr = this.sortArray(this.distributorArr);

      //sort id array
      this.movieIds.sort();
      this.versionIds.sort();
      this.weekIds.sort();
      this.distributorIds.sort();
    },
    sortArray(arr, isDate = false) {
      return arr.sort(function(a, b) {
        let keyA = isDate ? new Date(a.value) : a.value,
          keyB = isDate ?  new Date(b.value) : b.value;
        // Compare the 2 dates
        if (keyA < keyB) { return -1; }
        if (keyA > keyB) { return 1; }
        return 0;
      });
    },
    getFilterArr(type) {
      switch (type) {
      case "movie":
        return this.movieArr;
      case "version":
        return this.versionArr;
      case "week":
        return this.weekArr;
      case "distributor":
        return this.distributorArr;
      default:
        break;
      }
    },
    getFilterValueArr(type) {
      switch (type) {
      case "movie":
        return this.movieIds;
      case "version":
        return this.versionIds;
      case "week":
        return this.weekIds;
      case "distributor":
        return this.distributorIds;
      default:
        break;
      }
    },
    filter_fn(value) {
      // console.log("filter_fn");
      //clear filter
      this.filters_column = [];
      this.filters_values = [];

      let keys = Object.keys(value);
      let [ type ] = keys;

      this.filters_column = type;
      this.filters_values = value[type];

      this.getList(this.filters_column, this.filters_values, true);
    },
    search() {
      // console.log("search");
      this.getList(this.filters_column, this.filters_values, true);
    },
    getIsExistBoxOffice(key) {
      if (!this.showRule.includes("withoutTransactions") && this.tableData.length > 0) {
        return !this.tableData.every(
          item => item[key + '_salesTotal'] === 0 &&
          item[key + '_ticketAmount'] === 0 &&
          item[key + '_ticketQty'] === 0 &&
          item[key + '_vipAmount'] === 0 &&
          item[key + '_vipQty'] === 0
        );
      }
      return true;
    },
    getIsNeedTotal() {
      if(!this.showRule.includes("withoutTransactions") && this.tableData.length > 0) {
        return !(
          this.getIsExistBoxOffice("boxOffice") && 
          this.getIsExistBoxOffice("allNight") && 
          this.getIsExistBoxOffice("lateShow") && 
          this.getIsExistBoxOffice("morningShow") && 
          this.getIsExistBoxOffice("special"));
      }
      return true;
    },
    dateDisableDate(time) {
      return time.getTime() > this.$moment().valueOf();
    },
  },
};
</script>
